import type { JSX } from "react";

import { ContactCta } from "../../ContactCta";
import type { SectionRenderInput } from "./types";

/**
 * GET IN TOUCH — the guide's way to reach the team behind it. The form sends the
 * slug only; the inbox it lands in is the server's to know.
 */
export function ContactSection({ page }: SectionRenderInput): JSX.Element {
  return (
    <div className="atlas-guide-row atlas-guide-row--text-only">
      <p className="atlas-guide-prose">Send the team behind the {page.name} guide a message.</p>
      <ContactCta slug={page.slug} cityName={page.name} instagramHandle={page.instagramHandle} />
    </div>
  );
}
